import { DownloadOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import React, { useState } from "react";
import AntdIconV4 from "../../../../utils/antdIcon";
import { mediaDownloader } from "../../../../utils/mediaDownloader";
import { ModalStyled } from "./multipleMediaViewer";

export function ViewMediaPopup({ pdfModal, setpdfModal }) {
  const [displayError, setDisplayError] = useState(false);
  const [fallbackMethod, setFallbackMethod] = useState(null);
  const handlePDFLoadError = () => {
    setDisplayError(true);

    // Try alternative display methods
    setFallbackMethod(
      <object data={pdfModal.pdfUrl} type="application/pdf" width="100%" height="600px">
        <p>Unable to display PDF. Download or view in another application.</p>
      </object>
    );
  };
  return (
    <ModalStyled
      title={null}
      width="97.5%"
      open={pdfModal.visible}
      onCancel={() => setpdfModal({ visible: false, pdfUrl: "" })}
      wrapClassName="mediaModal"
      footer={null}
      closeIcon={
        <div className="flex flex-row items-center gap-2 pr-5">
          <Tooltip title="Download file">
            <a href={pdfModal?.pdfUrl} download>
              <DownloadOutlined
                onClick={e => {
                  e.stopPropagation();
                  // mediaDownloader(pdfModal?.pdfUrl, pdfModal?.mediaType?.split("/")[1]);
                }}
                className="text-white text-lg"
              />
            </a>
          </Tooltip>
          <AntdIconV4 type="CloseOutlined" className="text-white text-lg" />
        </div>
      }
    >
      {!displayError ? (
        <iframe
          allowFullScreen
          src={pdfModal.pdfUrl}
          onError={handlePDFLoadError}
          className="h-[85vh] w-[92vw] mt-[35px] media-view-iframe"
          title="PDF"
        />
      ) : (
        fallbackMethod || (
          <div>
            <p>PDF cannot be displayed</p>
            <a href={pdfModal.pdfUrl} download>
              Download PDF
            </a>
          </div>
        )
      )}
    </ModalStyled>
  );
}
